<script>
import Vue from 'vue'
import { GlobalBus } from '@services/bus'
import { MODAL, ACTION } from '@constants/Text'
import rules from '@constants/Rules'
import apiAtendimento from '@modules/atendimento/api/apiAtendimento'

export default {
  name: 'ModalRespostaRapida',
  props: {
    // API + chaves GlobalBus — default atendimento; solicitacoes injeta as suas.
    api: {
      type: Object,
      default: () => apiAtendimento,
    },
    openKey: {
      type: String,
      default: MODAL.ATENDIMENTO_RESPOSTA_RAPIDA,
    },
    salvaKey: {
      type: String,
      default: ACTION.ATENDIMENTO_RESPOSTA_RAPIDA_SALVA,
    },
  },
  data() {
    return {
      busModal: new Vue(),
      loading: false,
      editingItem: null,
      rules,
      form: {
        titulo: '',
        conteudo: '',
      },
    }
  },
  computed: {
    isEditing() {
      return !!this.editingItem
    },
    modalTitle() {
      return this.isEditing ? 'Editar Resposta' : 'Nova Resposta'
    },
    confirmLabel() {
      return this.isEditing ? 'Salvar' : 'Criar'
    },
  },
  created() {
    GlobalBus.$on(this.openKey, this.open)
  },
  beforeDestroy() {
    GlobalBus.$off(this.openKey, this.open)
  },
  methods: {
    clear() {
      this.loading = false
      this.editingItem = null
      this.form = { titulo: '', conteudo: '' }

      if (this.$refs.form) {
        this.$refs.form.resetValidation()
      }
    },

    open({ item } = {}) {
      this.clear()
      if (item) {
        this.editingItem = item
        this.form = {
          titulo: item.titulo || '',
          conteudo: item.conteudo || '',
        }
      }
      this.busModal.$emit('dialog', true)
    },

    async save() {
      if (this.loading) return

      if (this.$refs.form && !this.$refs.form.validate()) return

      this.loading = true
      try {
        let r
        const payload = {
          titulo: this.form.titulo.trim(),
          conteudo: this.form.conteudo.trim(),
        }
        if (this.isEditing) {
          r = await this.api.editarRespostaRapida({
            id: this.editingItem.id,
            ...payload,
          })
        } else {
          r = await this.api.criarRespostaRapida(payload)
        }

        this.$showSnack({
          text: (r && r.message) || 'Erro inesperado',
          color: r && r.status === 200 ? 'success' : 'error',
          button: true,
        })
        if (r && r.status === 200) {
          this.busModal.$emit('dialog', false)
          GlobalBus.$emit(this.salvaKey, r.value || null)
        }
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<template>
  <BaseModal
    centerScreen
    :bus="busModal"
    persistent
    centerAndDecreasesPadding
    maxWidth="520px"
    closeColor="#8e8e8e"
    backgroundColor="white"
  >
    <div class="pb-6">
      <div class="modal-title-container">
        <span class="modal-title">{{ modalTitle }}</span>
      </div>

      <div class="modal-content">
        <v-form ref="form">
          <div class="pa-4">
            <input-by-type
              v-model="form.titulo"
              type="text"
              outlined
              dense
              labelExternal="Título*"
              placeholder="Ex.: Saudação"
              :maxlength="100"
              data-test="form-titulo"
              class="mb-4"
              :rules="[rules.required]"
              style="min-width: 175px"
            />
            <div class="modal-textarea-container">
              <input-by-type
                v-model="form.conteudo"
                type="textarea-new-ux"
                labelExternal="Conteúdo*"
                placeholder="Digite o texto que será enviado..."
                rows="4"
                :rules="[rules.required]"
                data-test="form-conteudo"
              />
            </div>
          </div>
        </v-form>
      </div>
    </div>

    <template v-slot:actions="{ close }">
      <div class="mt-4 d-flex">
        <BaseButton underlined @click="close"> Cancelar </BaseButton>
        <BaseButton
          primary
          :loading="loading"
          :disabled="loading"
          data-test="save-resposta-btn"
          @click="save"
        >
          {{ confirmLabel }}
        </BaseButton>
      </div>
    </template>
  </BaseModal>
</template>
